// export this package's api
import Drawer from './DrawerWrapper';
export default Drawer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-drawer/es/index.js
// module id = 813
// module chunks = 0